<div class="grid-toolbar">
  @if (!bulkDeleteEnabled()) {
    <div class="toolbar-items">
      @if (showButton()) {
        @if (doRefresh()) {
          <button class="toolbar-btn" (click)="refreshClick.emit()">
            <i class="ph ph-arrow-clockwise"></i>
            <span>{{ 'refresh' | translate }}</span>
          </button>
        }
        @if (customToolbarVisible() && customToolbar().length) {
          @for (a of customToolbar(); track a.slug) {
            @if (!a.separator) {
              <button
                type="button"
                class="toolbar-btn"
                [disabled]="a.disabled || (!a.gridLevel && (disabledButton() || recordFetchLoading()))"
                (click)="customToolbarActionClick.emit(a)">
                <i [class]="a.icon || ''"></i>
                <span>{{ a.slug_2 ?? a.slug | translate }}</span>
              </button>
            }
          }
        }
        @if (doAdd() && !initStatesWithChild().length) {
          @if (initStatesWithoutChild().length === 0) {
            <button class="toolbar-btn" type="button" (click)="openNewClick.emit(undefined)">
              <i class="ph ph-plus"></i>
              <span>{{ 'add' | translate }}</span>
            </button>
          } @else if (initStatesWithoutChild().length === 1) {
            <button class="toolbar-btn" type="button" (click)="openNewClick.emit(initStatesWithoutChild()[0])">
              <i class="ph ph-plus"></i>
              <span>{{ 'add' | translate }}</span>
            </button>
          } @else {
            <div class="toolbar-btn-group">
              <button type="button" class="toolbar-btn" (click)="openNewClick.emit(initStatesWithoutChild()[0])">
                <i class="ph ph-plus"></i>
                <span>{{ 'add' | translate }}</span>
              </button>
              <button
                type="button"
                class="toolbar-btn toolbar-btn--dropdown"
                (click)="addInitStatesMenu.toggle($event)">
                <i class="ph ph-caret-down"></i>
              </button>
              <p-menu
                #addInitStatesMenu
                [model]="addInitStatesMenuModel()"
                [popup]="true"
                [appendTo]="menuAppendTo()" />
            </div>
          }
        }
        @if (doDelete()) {
          <button class="toolbar-btn" [disabled]="disabledButton()" (click)="deleteClick.emit()">
            <i class="ph ph-trash"></i>
            <span>{{ 'delete' | translate }}</span>
          </button>
        }
        @if (doEdit()) {
          <div class="toolbar-btn-group">
            <button
              class="toolbar-btn"
              [disabled]="disabledButton() || recordFetchLoading()"
              (click)="editClick.emit()">
              <i class="ph ph-pencil-simple"></i>
              <span>{{ 'edit' | translate }}</span>
            </button>
            @if (doView()) {
              <button
                type="button"
                class="toolbar-btn toolbar-btn--dropdown"
                [disabled]="disabledButton() || recordFetchLoading()"
                (click)="editViewMenu.toggle($event)">
                <i class="ph ph-caret-down"></i>
              </button>
              <p-menu #editViewMenu [model]="editViewMenuModel()" [popup]="true" [appendTo]="menuAppendTo()"></p-menu>
            }
          </div>
        }
        @if (doView() && !doEdit()) {
          <button class="toolbar-btn" [disabled]="disabledButton() || recordFetchLoading()" (click)="viewClick.emit()">
            <i class="ph ph-eye"></i>
            <span>{{ 'view' | translate }}</span>
          </button>
        }
        @if (filterable()) {
          <div class="toolbar-btn-group">
            <button class="toolbar-btn" (click)="toggleFilterClick.emit()">
              <i class="ph ph-funnel"></i>
              <span>{{ 'filter' | translate }}</span>
            </button>
            @if (customFilter()) {
              <button type="button" class="toolbar-btn toolbar-btn--dropdown" (click)="filterMenu.toggle($event)">
                <i class="ph ph-caret-down"></i>
              </button>
              <p-menu #filterMenu [model]="filterMenuModel()" [popup]="true" [appendTo]="menuAppendTo()"></p-menu>
            }
          </div>
        }
        @if (doExport()) {
          <div class="toolbar-btn-group">
            <button
              type="button"
              class="toolbar-btn"
              [disabled]="disabledButton()"
              (click)="exportClick.emit('page')">
              <i class="ph ph-file-xls"></i>
              <span>{{ 'export' | translate }}</span>
            </button>
            <button
              type="button"
              class="toolbar-btn toolbar-btn--dropdown"
              [disabled]="disabledButton()"
              (click)="exportMenu.toggle($event)">
              <i class="ph ph-caret-down"></i>
            </button>
            <p-menu #exportMenu [model]="exportMenuModel()" [popup]="true" [appendTo]="menuAppendTo()" />
          </div>
        }
        @if (fullscreenEnabled()) {
          <button class="toolbar-btn" type="button" (click)="toggleFullscreenClick.emit()">
            <i [class]="fullscreenActive() ? 'ph ph-corners-in' : 'ph ph-corners-out'"></i>
            <span>{{ (fullscreenActive() ? 'exit_fullscreen' : 'fullscreen') | translate }}</span>
          </button>
        }
        @if (showProcessesMenu()) {
          <div class="toolbar-btn-group">
            <button
              type="button"
              class="toolbar-btn"
              [disabled]="disabledButton()"
              (click)="processesMenu.toggle($event)">
              <i class="ph ph-list-checks"></i>
              <span>{{ 'processes' | translate }}</span>
              <i class="ph ph-caret-down toolbar-btn-chevron"></i>
            </button>
            <p-menu #processesMenu [model]="processesMenuModel()" [popup]="true" [appendTo]="menuAppendTo()"></p-menu>
          </div>
        }
        @if (hasOtherMenu()) {
          <div class="toolbar-btn-group">
            <button type="button" class="toolbar-btn" [disabled]="disabledButton()" (click)="otherMenu.toggle($event)">
              <i class="ph ph-list"></i>
              <span>{{ 'other' | translate }}</span>
              <i class="ph ph-caret-down toolbar-btn-chevron"></i>
            </button>
            <p-menu #otherMenu [model]="otherMenuModel()" [popup]="true" [appendTo]="menuAppendTo()"></p-menu>
          </div>
        }
      }
    </div>
  } @else {
    <div class="toolbar-items">
      <button class="toolbar-btn toolbar-btn--ok" (click)="confirmBulkDeleteClick.emit()">
        <i class="ph ph-check"></i>
        <span>{{ 'ok' | translate }}</span>
      </button>
      <button class="toolbar-btn toolbar-btn--cancel" (click)="cancelBulkDeleteClick.emit()">
        <i class="ph ph-x"></i>
        <span>{{ 'cancel' | translate }}</span>
      </button>
    </div>
  }
</div>
